import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "../actions/resetAll";

const authSlice = createSlice({
  name: "auth",
  initialState: { isAuthenticated: false, mpinFailedAttempts: 0, isVersionAllowed: true },
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    increaseMpinFailedAttempts: (state) => {
      state.mpinFailedAttempts += 1;
    },
    resetMpinFailedAttempts: (state) => {
      state.mpinFailedAttempts = 0;
    },
    setIsVersionAllowed: (state, action) => {
      state.isVersionAllowed = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder.addCase(resetAll, () => ({
      isAuthenticated: false,
      mpinFailedAttempts: 0,
      isVersionAllowed: true,
    })),
});

export const { reducer: authReducer, actions: authActions } = authSlice;

export default authSlice;
